import { render, staticRenderFns } from "./compliance_tests.vue?vue&type=template&id=78d52ff0&scoped=true"
import script from "./compliance_tests.vue?vue&type=script&lang=js"
export * from "./compliance_tests.vue?vue&type=script&lang=js"
import style0 from "./compliance_tests.vue?vue&type=style&index=0&id=78d52ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d52ff0",
  null
  
)

export default component.exports